// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// https://api.sma.infi.cf/frontend
// https://api.dev.stockaladdin.com/frontend

export const environment = {
  production: false,
  baseUrl: 'https://api.nobiasinvesting.com/frontend',
  apiUrl: 'https://api.nobiasinvesting.com',
  googleKey: '905836978702-a3dikeauev9kdce2851lf0s08s9u7fcp.apps.googleusercontent.com',
  reCatchSiteKey: '6LeMzZAdAAAAABM78i3uNU5ZO8WrMq_c0K4EGhdH',
  reCatchSecretKey: '6LeMzZAdAAAAAEoJSn-jaUpTuH_KisYlZHwzdJVQ'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
